import React from 'react';

import { PersonProvider } from '../../context/person.provider';

import { Executor } from './executor';

interface Person {
  id: string;
  personId: string;
  firstName: string;
  lastName: string;
  contactEmail?: string;
  contactPhone?: string;
}

interface ExecutorListProps {
  executors: Person[];
  onRemove: (executor: Person) => void;
}

export function ExecutorList({ executors, onRemove }: ExecutorListProps) {
  // TODO: fix id or personId
  return (
    <div className="asset-list">
      {executors.map((executor) => (
        <PersonProvider key={executor.id} id={executor.personId || executor.id}>
          <Executor
            key={executor.id}
            onRemove={onRemove}
          />
        </PersonProvider>
      ))}
    </div>
  );
}
